export type ToastType =
  | "success"
  | "info"
  | "warning"
  | "error-soft"
  | "error-hard"
  | "progress"
  | "partial";

export type ToastAction = "Retry" | "Try again" | "Undo" | "View details" | "Open" | "View" | "Contact us";

export interface ShowToastOptions {
  type: ToastType;
  title: string;
  body?: string;
  action?: { label: ToastAction; onClick: () => void };
  dedupeKey?: string;
  progress?: number;
}

export interface TypeHeroToast {
  id: string;
  type: ToastType;
  title: string;
  body?: string;
  action?: { label: ToastAction; onClick: () => void };
  progress?: number;
  _createdAt: number;
  _dedupeKey?: string;
  _count?: number;
  _paused?: boolean;
  _exiting?: boolean;
}

export const TOAST_PRIORITY: Record<ToastType, number> = {
  "error-hard": 6,
  "error-soft": 5,
  warning: 4,
  partial: 4,
  progress: 3,
  info: 2,
  success: 1,
};

export const TOAST_DURATION: Record<ToastType, number> = {
  success: 3000,
  info: 4000,
  warning: 7000,
  "error-soft": 8000,
  "error-hard": 0,
  progress: 0,
  partial: 7000,
};

export const MAX_VISIBLE = 3;
export const RATE_LIMIT_MS = 500;
export const DEDUPE_WINDOW_MS = 2000;
export const UNDO_DURATION = 6000;

export const ANIMATION = {
  enter: 200,
  exit: 160,
  resumeGrace: 800,
  resumeFraction: 0.4,
} as const;
